export default __webpack_public_path__ + "static/media/fb-taraftart-card.c5d71d5b.png";